var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantBankTransferFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.657 10A7.492 7.492 0 0022 12.342V19a1 1 0 01-1 1H3a1 1 0 01-1-1v-9h9.657zM6 15a1 1 0 100 2h4l.102-.005a1 1 0 000-1.99L10 15H6z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0a6 6 0 110 12 6 6 0 010-12zm.583 2.5a.254.254 0 00-.21.113l-2.61 3.912a.254.254 0 00.212.395h.887c.154 0 .273.136.252.289l-.277 2.002a.254.254 0 00.25.289h.027c.077 0 .15-.035.198-.095l2.857-3.558a.254.254 0 00-.198-.413h-1.152a.254.254 0 01-.252-.285l.285-2.365a.254.254 0 00-.251-.284h-.018z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.771 4a7.505 7.505 0 000 4H2V5a1 1 0 011-1h7.771z",
    fill: "currentColor"
  })));
}
SvgInstantBankTransferFilled.displayName = 'InstantBankTransferFilled';
export default SvgInstantBankTransferFilled;